import { createSelector } from '@reduxjs/toolkit';

import { noFilterView } from '../store/viewsSlice';
import { getActiveView } from './getActiveView';

export const isActiveViewFiltered = createSelector(
  getActiveView,
  (activeView) =>
    activeView.jobFilters.length !== noFilterView.jobFilters.length ||
    activeView.visibleColumns.length !== noFilterView.visibleColumns.length,
);
